import { Link, useMatch } from "react-location";
import { OfficeHeader, Tabs } from "components";
import { classNames, useUrlState } from "utils";

import Associates from "./tabs/associates";
// import _ from "lodash";
import { FC } from "react";
import { LocationGenerics } from "router/location";
import OverviewTab from "./tabs/overview";
import TreatiesTabForBroker from "./tabs/treaties";
import { useBroker } from "hooks/data/use-brokers";

// import OfferParticipation from "./participations";
// import Associates from "./associates";

type Props = {};

const tabs = [{ name: "Treaties", href: "treaties" }, { name: "Associates", href: "associates" }];

const ReInsurerPage: FC<Props> = (props) => {
    const { params } = useMatch<LocationGenerics>();
    const [orderStatus] = useUrlState("orderStatus");

    const { broker, loading: loadingReinsirer } = useBroker(
        params.broker as string
    );

    return (
        <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
            <OfficeHeader />
            <header>
                <div className="flex flex-col items-start justify-between gap-x-8 gap-y-4 bg-background-500 px-4 py-4 sm:flex-row sm:items-center sm:px-6 lg:px-8">
                    <div>
                        <div className="flex items-center gap-x-3">
                            <div className="flex-none rounded-full bg-green-400/10 p-1 text-green-400">
                                <div className="h-2 w-2 rounded-full bg-current" />
                            </div>
                            <h1 className="flex gap-x-3 text-base leading-7">
                                <span className="font-semibold text-primary">
                                    {loadingReinsirer
                                        ? "loading ..."
                                        : broker?.re_broker_name}
                                </span>
                                <span className="text-gray-600">/</span>
                                <span className="font-semibold text-primary">
                                    {loadingReinsirer ? "..." : broker?.re_broker_address?.country}
                                </span>
                            </h1>
                        </div>
                        <p className="mt-2 text-xs leading-6 text-tertiary">
                            {broker?.re_broker_email} / {broker?.re_broker_address?.re_primary_phone}
                        </p>
                    </div>
                    <div className="order-first flex-none rounded-full bg-indigo-400/10 px-2 py-1 text-xs font-medium text-indigo-400 ring-1 ring-inset ring-indigo-400/30 sm:order-none">
                        Active
                    </div>
                </div>
            </header>
            <Tabs
                tabs={tabs}
                orderStatus={orderStatus}
                defaultTab="Overview"
            />
            <div className="flex flex-1 overflow-y-auto">
                <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
                    {!orderStatus && <OverviewTab broker={broker} />}
                    {orderStatus === "treaties" && <TreatiesTabForBroker />}
                    {orderStatus === "associates" && <Associates />}
                </div>
            </div>
        </main>
    );
};

export default ReInsurerPage;
